import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, Row, Table } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import Id from "../../../components/Formatters/Id";
import IE from "../../../components/Formatters/IE";
import FileDownloader from "../../../components/UI/Button/FileDownloader";

const DetalheDenuncia = (id) => {
  const [dados, setDados] = useState({});
  const [semDados, setSemDados] = useState(false);
  const [denuncia, setDenuncia] = useState({});
  const { request, data, errors, isLoading } = useApiClient();
  const { request: requestDownload, data: dataDownload } = useApiClient();

  useEffect(() => {
    setDenuncia(id);
  }, [id]);

  useEffect(() => {
    request(apiRoutes.fiscalizacao.procedimentoFiscal.detalhaDenuncia, { id: denuncia.id });

    const paramsDenuncia = { sqDenuncia: denuncia.id };
    requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadDenuncia, paramsDenuncia);
  }, [denuncia, request, requestDownload]);

  useEffect(() => {
    if ((!data && !errors) || isLoading) return;

    if (data && data.result) {
      setDados(data.result);
      setSemDados(false);
    }

    if (!data) {
      setSemDados(true);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, isLoading]);

  return (
    <>
      {/* Cabeçalho da Página */}
      <div className="row">
        <div className="col-lg-12">
          {!semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <Col sm="12" className="d-flex">
                    <h5 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                      Denúncia nº {denuncia.id}
                    </h5>
                    <FileDownloader
                      binario={dataDownload}
                      tooltip={`Visualizar denúncia ${denuncia.id}`}
                      className="ml-2"
                    />
                  </Col>
                  <Col sm="1" className="text-right" />
                </Row>
              </div>
              <div className="card-body">
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="12">
                    <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">Denunciado:</h6>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Nome
                    <br />
                    <b>{dados.nomeEstabelecimento}</b>
                  </Col>
                  <Col sm="3">
                    CNPJ/CPF
                    <br />
                    <b>
                      <Id value={dados.cpfCnpj} />
                    </b>
                  </Col>
                  <Col sm="2">
                    Inscrição Estadual
                    <br />
                    <b>
                      <IE value={dados.inscricaoEstadual} empty="-" />
                    </b>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Endereço
                    <br />
                    <b>{dados.enderecoEstabelecimento}</b>
                  </Col>
                  <Col sm="5">
                    Telefone:
                    <br />
                    <b>{dados.telefoneEstabelecimento}</b>
                  </Col>
                </Row>
                <Row className="py-2">
                  <Col sm="12">
                    <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">Descrição:</h6>
                    <b>{dados.descricaoDenuncia}</b>
                    <br />
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="12">
                    <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">Denunciante:</h6>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Nome
                    <br />
                    <b>{dados.textoNome}</b>
                  </Col>
                  <Col sm="3">
                    Email
                    <br />
                    <b>{dados.textoEmail}</b>
                  </Col>
                  <Col sm="2">
                    Telefone
                    <br />
                    <b>{dados.textoTelefone}</b>
                  </Col>
                </Row>
                <Row className="py-2">
                  <Col sm="12">
                    <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                      Histórico da Reclamação:
                    </h6>
                    {dados?.reclamacoes?.length === 0 ||
                      (dados?.reclamacoes?.length === undefined && <h6>Nenhum Histórico Encontrado.</h6>)}
                    {dados?.reclamacoes?.length > 0 && (
                      <Table>
                        <thead>
                          <tr>
                            <th sm="7">Descrição</th>
                            <th sm="2">Data Inclusão</th>
                            <th sm="3">Usuário Inclusão</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dados.reclamacoes.map((reclamacao) => (
                            <tr>
                              <td>{reclamacao.descricao}</td>
                              <td>{new Date(reclamacao.dataInclusao).toISOString()}</td>
                              <td>{reclamacao.usuarioInclusao}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </Col>
                </Row>

                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    <Button
                      variant="danger"
                      onClick={() => {
                        window.close();
                      }}
                    >
                      Voltar
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          {semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                    Nenhuma denúncia encontrada.
                  </h6>
                </Row>
                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    {denuncia.id == null ? (
                      <Button
                        variant="danger"
                        onClick={() => {
                          window.close();
                        }}
                      >
                        Voltar
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* fim da row */}
    </>
  );
};

export default DetalheDenuncia;
